// source: acompanha/orders/v1/orders.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.orders.v1.DeleteOrderRequest', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.GetOrderRequest', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.GetOrderResponse', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.GetOrderTransactionRequest', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.GetOrderTransactionResponse', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.GetOrdersSummaryRequest', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.GetOrdersSummaryResponse', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.ListOrdersRequest', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.ListOrdersResponse', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.Order', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.OrderListItem', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.OrderTopProduct', null, global);
goog.exportSymbol('proto.acompanha.orders.v1.TransactionSummary', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.Order = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.orders.v1.Order.repeatedFields_, null);
};
goog.inherits(proto.acompanha.orders.v1.Order, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.Order.displayName = 'proto.acompanha.orders.v1.Order';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.OrderListItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.orders.v1.OrderListItem.repeatedFields_, null);
};
goog.inherits(proto.acompanha.orders.v1.OrderListItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.OrderListItem.displayName = 'proto.acompanha.orders.v1.OrderListItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.ListOrdersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.orders.v1.ListOrdersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.ListOrdersRequest.displayName = 'proto.acompanha.orders.v1.ListOrdersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.OrderTopProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.orders.v1.OrderTopProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.OrderTopProduct.displayName = 'proto.acompanha.orders.v1.OrderTopProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.orders.v1.GetOrdersSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.GetOrdersSummaryRequest.displayName = 'proto.acompanha.orders.v1.GetOrdersSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.orders.v1.GetOrdersSummaryResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.orders.v1.GetOrdersSummaryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.GetOrdersSummaryResponse.displayName = 'proto.acompanha.orders.v1.GetOrdersSummaryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.ListOrdersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.orders.v1.ListOrdersResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.orders.v1.ListOrdersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.ListOrdersResponse.displayName = 'proto.acompanha.orders.v1.ListOrdersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.GetOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.orders.v1.GetOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.GetOrderRequest.displayName = 'proto.acompanha.orders.v1.GetOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.GetOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.orders.v1.GetOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.GetOrderResponse.displayName = 'proto.acompanha.orders.v1.GetOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.DeleteOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.orders.v1.DeleteOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.DeleteOrderRequest.displayName = 'proto.acompanha.orders.v1.DeleteOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.TransactionSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.orders.v1.TransactionSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.TransactionSummary.displayName = 'proto.acompanha.orders.v1.TransactionSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.GetOrderTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.orders.v1.GetOrderTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.GetOrderTransactionRequest.displayName = 'proto.acompanha.orders.v1.GetOrderTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.orders.v1.GetOrderTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.orders.v1.GetOrderTransactionResponse.displayName = 'proto.acompanha.orders.v1.GetOrderTransactionResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.orders.v1.Order.repeatedFields_ = [4,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.Order.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.Order.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.Order} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.Order.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
customer: (f = msg.getCustomer()) && acompanha_common_v1_common_pb.CustomerRef.toObject(includeInstance, f),
shippingMethod: (f = msg.getShippingMethod()) && acompanha_common_v1_common_pb.ShippingMethodRef.toObject(includeInstance, f),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    acompanha_common_v1_common_pb.CheckoutProduct.toObject, includeInstance),
amount: jspb.Message.getFieldWithDefault(msg, 5, 0),
salesChannel: (f = msg.getSalesChannel()) && acompanha_common_v1_common_pb.SalesChannelRef.toObject(includeInstance, f),
finishOrder: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
paymentMethodsList: jspb.Message.toObjectList(msg.getPaymentMethodsList(),
    acompanha_common_v1_common_pb.PaymentMethod.toObject, includeInstance),
paymentDetails: (f = msg.getPaymentDetails()) && acompanha_common_v1_common_pb.PaymentDetails.toObject(includeInstance, f),
paymentReceived: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
photo: jspb.Message.getFieldWithDefault(msg, 11, ""),
photoUrl: jspb.Message.getFieldWithDefault(msg, 12, ""),
isQuickCheckout: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
useQuickCheckoutCreationDate: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
expectedNet: jspb.Message.getFieldWithDefault(msg, 17, 0),
bankReconciled: jspb.Message.getBooleanFieldWithDefault(msg, 18, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.Order}
 */
proto.acompanha.orders.v1.Order.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.Order;
  return proto.acompanha.orders.v1.Order.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.Order} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.Order}
 */
proto.acompanha.orders.v1.Order.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.CustomerRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.CustomerRef.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.ShippingMethodRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.ShippingMethodRef.deserializeBinaryFromReader);
      msg.setShippingMethod(value);
      break;
    case 4:
      var value = new acompanha_common_v1_common_pb.CheckoutProduct;
      reader.readMessage(value,acompanha_common_v1_common_pb.CheckoutProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 6:
      var value = new acompanha_common_v1_common_pb.SalesChannelRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.SalesChannelRef.deserializeBinaryFromReader);
      msg.setSalesChannel(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFinishOrder(value);
      break;
    case 8:
      var value = new acompanha_common_v1_common_pb.PaymentMethod;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentMethod.deserializeBinaryFromReader);
      msg.addPaymentMethods(value);
      break;
    case 9:
      var value = new acompanha_common_v1_common_pb.PaymentDetails;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentDetails.deserializeBinaryFromReader);
      msg.setPaymentDetails(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaymentReceived(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoto(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhotoUrl(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsQuickCheckout(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseQuickCheckoutCreationDate(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpectedNet(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBankReconciled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.Order.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.Order.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.Order} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.Order.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.CustomerRef.serializeBinaryToWriter
    );
  }
  f = message.getShippingMethod();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      acompanha_common_v1_common_pb.ShippingMethodRef.serializeBinaryToWriter
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      acompanha_common_v1_common_pb.CheckoutProduct.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSalesChannel();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      acompanha_common_v1_common_pb.SalesChannelRef.serializeBinaryToWriter
    );
  }
  f = message.getFinishOrder();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPaymentMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      acompanha_common_v1_common_pb.PaymentMethod.serializeBinaryToWriter
    );
  }
  f = message.getPaymentDetails();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      acompanha_common_v1_common_pb.PaymentDetails.serializeBinaryToWriter
    );
  }
  f = message.getPaymentReceived();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getPhoto();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPhotoUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getIsQuickCheckout();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getUseQuickCheckoutCreationDate();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExpectedNet();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getBankReconciled();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.orders.v1.Order.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.common.v1.CustomerRef customer = 2;
 * @return {?proto.acompanha.common.v1.CustomerRef}
 */
proto.acompanha.orders.v1.Order.prototype.getCustomer = function() {
  return /** @type{?proto.acompanha.common.v1.CustomerRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.CustomerRef, 2));
};


/**
 * @param {?proto.acompanha.common.v1.CustomerRef|undefined} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
*/
proto.acompanha.orders.v1.Order.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional acompanha.common.v1.ShippingMethodRef shipping_method = 3;
 * @return {?proto.acompanha.common.v1.ShippingMethodRef}
 */
proto.acompanha.orders.v1.Order.prototype.getShippingMethod = function() {
  return /** @type{?proto.acompanha.common.v1.ShippingMethodRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.ShippingMethodRef, 3));
};


/**
 * @param {?proto.acompanha.common.v1.ShippingMethodRef|undefined} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
*/
proto.acompanha.orders.v1.Order.prototype.setShippingMethod = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.clearShippingMethod = function() {
  return this.setShippingMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.hasShippingMethod = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated acompanha.common.v1.CheckoutProduct products = 4;
 * @return {!Array<!proto.acompanha.common.v1.CheckoutProduct>}
 */
proto.acompanha.orders.v1.Order.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.CheckoutProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.CheckoutProduct, 4));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.CheckoutProduct>} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
*/
proto.acompanha.orders.v1.Order.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.acompanha.common.v1.CheckoutProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.CheckoutProduct}
 */
proto.acompanha.orders.v1.Order.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.acompanha.common.v1.CheckoutProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional int64 amount = 5;
 * @return {number}
 */
proto.acompanha.orders.v1.Order.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional acompanha.common.v1.SalesChannelRef sales_channel = 6;
 * @return {?proto.acompanha.common.v1.SalesChannelRef}
 */
proto.acompanha.orders.v1.Order.prototype.getSalesChannel = function() {
  return /** @type{?proto.acompanha.common.v1.SalesChannelRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.SalesChannelRef, 6));
};


/**
 * @param {?proto.acompanha.common.v1.SalesChannelRef|undefined} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
*/
proto.acompanha.orders.v1.Order.prototype.setSalesChannel = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.clearSalesChannel = function() {
  return this.setSalesChannel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.hasSalesChannel = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool finish_order = 7;
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.getFinishOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setFinishOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated acompanha.common.v1.PaymentMethod payment_methods = 8;
 * @return {!Array<!proto.acompanha.common.v1.PaymentMethod>}
 */
proto.acompanha.orders.v1.Order.prototype.getPaymentMethodsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.PaymentMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.PaymentMethod, 8));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.PaymentMethod>} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
*/
proto.acompanha.orders.v1.Order.prototype.setPaymentMethodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.acompanha.common.v1.PaymentMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.PaymentMethod}
 */
proto.acompanha.orders.v1.Order.prototype.addPaymentMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.acompanha.common.v1.PaymentMethod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.clearPaymentMethodsList = function() {
  return this.setPaymentMethodsList([]);
};


/**
 * optional acompanha.common.v1.PaymentDetails payment_details = 9;
 * @return {?proto.acompanha.common.v1.PaymentDetails}
 */
proto.acompanha.orders.v1.Order.prototype.getPaymentDetails = function() {
  return /** @type{?proto.acompanha.common.v1.PaymentDetails} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaymentDetails, 9));
};


/**
 * @param {?proto.acompanha.common.v1.PaymentDetails|undefined} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
*/
proto.acompanha.orders.v1.Order.prototype.setPaymentDetails = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.clearPaymentDetails = function() {
  return this.setPaymentDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.hasPaymentDetails = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool payment_received = 10;
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.getPaymentReceived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setPaymentReceived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string photo = 11;
 * @return {string}
 */
proto.acompanha.orders.v1.Order.prototype.getPhoto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setPhoto = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string photo_url = 12;
 * @return {string}
 */
proto.acompanha.orders.v1.Order.prototype.getPhotoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setPhotoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool is_quick_checkout = 13;
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.getIsQuickCheckout = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setIsQuickCheckout = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool use_quick_checkout_creation_date = 14;
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.getUseQuickCheckoutCreationDate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setUseQuickCheckoutCreationDate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.orders.v1.Order.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
*/
proto.acompanha.orders.v1.Order.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.orders.v1.Order.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
*/
proto.acompanha.orders.v1.Order.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional int64 expected_net = 17;
 * @return {number}
 */
proto.acompanha.orders.v1.Order.prototype.getExpectedNet = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setExpectedNet = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional bool bank_reconciled = 18;
 * @return {boolean}
 */
proto.acompanha.orders.v1.Order.prototype.getBankReconciled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.orders.v1.Order} returns this
 */
proto.acompanha.orders.v1.Order.prototype.setBankReconciled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.orders.v1.OrderListItem.repeatedFields_ = [3,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.OrderListItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.OrderListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.OrderListItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
customer: (f = msg.getCustomer()) && acompanha_common_v1_common_pb.CustomerRef.toObject(includeInstance, f),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    acompanha_common_v1_common_pb.CheckoutProduct.toObject, includeInstance),
salesChannel: (f = msg.getSalesChannel()) && acompanha_common_v1_common_pb.SalesChannelRef.toObject(includeInstance, f),
shippingMethod: (f = msg.getShippingMethod()) && acompanha_common_v1_common_pb.ShippingMethodRef.toObject(includeInstance, f),
amount: jspb.Message.getFieldWithDefault(msg, 6, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
paymentMethodsList: jspb.Message.toObjectList(msg.getPaymentMethodsList(),
    acompanha_common_v1_common_pb.PaymentMethod.toObject, includeInstance),
paymentDetails: (f = msg.getPaymentDetails()) && acompanha_common_v1_common_pb.PaymentDetails.toObject(includeInstance, f),
paymentReceived: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
expectedNet: jspb.Message.getFieldWithDefault(msg, 11, 0),
bankReconciled: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.OrderListItem}
 */
proto.acompanha.orders.v1.OrderListItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.OrderListItem;
  return proto.acompanha.orders.v1.OrderListItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.OrderListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.OrderListItem}
 */
proto.acompanha.orders.v1.OrderListItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.CustomerRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.CustomerRef.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.CheckoutProduct;
      reader.readMessage(value,acompanha_common_v1_common_pb.CheckoutProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 4:
      var value = new acompanha_common_v1_common_pb.SalesChannelRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.SalesChannelRef.deserializeBinaryFromReader);
      msg.setSalesChannel(value);
      break;
    case 5:
      var value = new acompanha_common_v1_common_pb.ShippingMethodRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.ShippingMethodRef.deserializeBinaryFromReader);
      msg.setShippingMethod(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = new acompanha_common_v1_common_pb.PaymentMethod;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentMethod.deserializeBinaryFromReader);
      msg.addPaymentMethods(value);
      break;
    case 9:
      var value = new acompanha_common_v1_common_pb.PaymentDetails;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentDetails.deserializeBinaryFromReader);
      msg.setPaymentDetails(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaymentReceived(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpectedNet(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBankReconciled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.OrderListItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.OrderListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.OrderListItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.CustomerRef.serializeBinaryToWriter
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      acompanha_common_v1_common_pb.CheckoutProduct.serializeBinaryToWriter
    );
  }
  f = message.getSalesChannel();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      acompanha_common_v1_common_pb.SalesChannelRef.serializeBinaryToWriter
    );
  }
  f = message.getShippingMethod();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      acompanha_common_v1_common_pb.ShippingMethodRef.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPaymentMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      acompanha_common_v1_common_pb.PaymentMethod.serializeBinaryToWriter
    );
  }
  f = message.getPaymentDetails();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      acompanha_common_v1_common_pb.PaymentDetails.serializeBinaryToWriter
    );
  }
  f = message.getPaymentReceived();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getExpectedNet();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getBankReconciled();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.common.v1.CustomerRef customer = 2;
 * @return {?proto.acompanha.common.v1.CustomerRef}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getCustomer = function() {
  return /** @type{?proto.acompanha.common.v1.CustomerRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.CustomerRef, 2));
};


/**
 * @param {?proto.acompanha.common.v1.CustomerRef|undefined} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
*/
proto.acompanha.orders.v1.OrderListItem.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated acompanha.common.v1.CheckoutProduct products = 3;
 * @return {!Array<!proto.acompanha.common.v1.CheckoutProduct>}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.CheckoutProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.CheckoutProduct, 3));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.CheckoutProduct>} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
*/
proto.acompanha.orders.v1.OrderListItem.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.common.v1.CheckoutProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.CheckoutProduct}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.common.v1.CheckoutProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional acompanha.common.v1.SalesChannelRef sales_channel = 4;
 * @return {?proto.acompanha.common.v1.SalesChannelRef}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getSalesChannel = function() {
  return /** @type{?proto.acompanha.common.v1.SalesChannelRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.SalesChannelRef, 4));
};


/**
 * @param {?proto.acompanha.common.v1.SalesChannelRef|undefined} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
*/
proto.acompanha.orders.v1.OrderListItem.prototype.setSalesChannel = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.clearSalesChannel = function() {
  return this.setSalesChannel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.hasSalesChannel = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional acompanha.common.v1.ShippingMethodRef shipping_method = 5;
 * @return {?proto.acompanha.common.v1.ShippingMethodRef}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getShippingMethod = function() {
  return /** @type{?proto.acompanha.common.v1.ShippingMethodRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.ShippingMethodRef, 5));
};


/**
 * @param {?proto.acompanha.common.v1.ShippingMethodRef|undefined} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
*/
proto.acompanha.orders.v1.OrderListItem.prototype.setShippingMethod = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.clearShippingMethod = function() {
  return this.setShippingMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.hasShippingMethod = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 amount = 6;
 * @return {number}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
*/
proto.acompanha.orders.v1.OrderListItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated acompanha.common.v1.PaymentMethod payment_methods = 8;
 * @return {!Array<!proto.acompanha.common.v1.PaymentMethod>}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getPaymentMethodsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.PaymentMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.PaymentMethod, 8));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.PaymentMethod>} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
*/
proto.acompanha.orders.v1.OrderListItem.prototype.setPaymentMethodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.acompanha.common.v1.PaymentMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.PaymentMethod}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.addPaymentMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.acompanha.common.v1.PaymentMethod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.clearPaymentMethodsList = function() {
  return this.setPaymentMethodsList([]);
};


/**
 * optional acompanha.common.v1.PaymentDetails payment_details = 9;
 * @return {?proto.acompanha.common.v1.PaymentDetails}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getPaymentDetails = function() {
  return /** @type{?proto.acompanha.common.v1.PaymentDetails} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaymentDetails, 9));
};


/**
 * @param {?proto.acompanha.common.v1.PaymentDetails|undefined} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
*/
proto.acompanha.orders.v1.OrderListItem.prototype.setPaymentDetails = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.clearPaymentDetails = function() {
  return this.setPaymentDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.hasPaymentDetails = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool payment_received = 10;
 * @return {boolean}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getPaymentReceived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.setPaymentReceived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int64 expected_net = 11;
 * @return {number}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getExpectedNet = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.setExpectedNet = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional bool bank_reconciled = 12;
 * @return {boolean}
 */
proto.acompanha.orders.v1.OrderListItem.prototype.getBankReconciled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.orders.v1.OrderListItem} returns this
 */
proto.acompanha.orders.v1.OrderListItem.prototype.setBankReconciled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.ListOrdersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.ListOrdersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.ListOrdersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
salesChannelId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.ListOrdersRequest}
 */
proto.acompanha.orders.v1.ListOrdersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.ListOrdersRequest;
  return proto.acompanha.orders.v1.ListOrdersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.ListOrdersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.ListOrdersRequest}
 */
proto.acompanha.orders.v1.ListOrdersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalesChannelId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.ListOrdersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.ListOrdersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.ListOrdersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSalesChannelId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.orders.v1.ListOrdersRequest} returns this
*/
proto.acompanha.orders.v1.ListOrdersRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.ListOrdersRequest} returns this
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.orders.v1.ListOrdersRequest} returns this
*/
proto.acompanha.orders.v1.ListOrdersRequest.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.ListOrdersRequest} returns this
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.orders.v1.ListOrdersRequest} returns this
*/
proto.acompanha.orders.v1.ListOrdersRequest.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.ListOrdersRequest} returns this
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.hasTo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string sales_channel_id = 4;
 * @return {string}
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.getSalesChannelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.ListOrdersRequest} returns this
 */
proto.acompanha.orders.v1.ListOrdersRequest.prototype.setSalesChannelId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.OrderTopProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.OrderTopProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.OrderTopProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.OrderTopProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.OrderTopProduct}
 */
proto.acompanha.orders.v1.OrderTopProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.OrderTopProduct;
  return proto.acompanha.orders.v1.OrderTopProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.OrderTopProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.OrderTopProduct}
 */
proto.acompanha.orders.v1.OrderTopProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.OrderTopProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.OrderTopProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.OrderTopProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.OrderTopProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.orders.v1.OrderTopProduct.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.OrderTopProduct} returns this
 */
proto.acompanha.orders.v1.OrderTopProduct.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.acompanha.orders.v1.OrderTopProduct.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.OrderTopProduct} returns this
 */
proto.acompanha.orders.v1.OrderTopProduct.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.GetOrdersSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
q: jspb.Message.getFieldWithDefault(msg, 1, ""),
from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
salesChannelId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryRequest}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.GetOrdersSummaryRequest;
  return proto.acompanha.orders.v1.GetOrdersSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryRequest}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQ(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalesChannelId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.GetOrdersSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQ();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSalesChannelId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string q = 1;
 * @return {string}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.getQ = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.setQ = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} returns this
*/
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} returns this
*/
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.hasTo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string sales_channel_id = 4;
 * @return {string}
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.getSalesChannelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryRequest.prototype.setSalesChannelId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.GetOrdersSummaryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalSales: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalProducts: jspb.Message.getFieldWithDefault(msg, 2, 0),
averageTicket: jspb.Message.getFieldWithDefault(msg, 3, 0),
topProductsList: jspb.Message.toObjectList(msg.getTopProductsList(),
    proto.acompanha.orders.v1.OrderTopProduct.toObject, includeInstance),
from: jspb.Message.getFieldWithDefault(msg, 5, ""),
to: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryResponse}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.GetOrdersSummaryResponse;
  return proto.acompanha.orders.v1.GetOrdersSummaryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryResponse}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalSales(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalProducts(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAverageTicket(value);
      break;
    case 4:
      var value = new proto.acompanha.orders.v1.OrderTopProduct;
      reader.readMessage(value,proto.acompanha.orders.v1.OrderTopProduct.deserializeBinaryFromReader);
      msg.addTopProducts(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.GetOrdersSummaryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalSales();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalProducts();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAverageTicket();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTopProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.acompanha.orders.v1.OrderTopProduct.serializeBinaryToWriter
    );
  }
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 total_sales = 1;
 * @return {number}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.getTotalSales = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.setTotalSales = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_products = 2;
 * @return {number}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.getTotalProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.setTotalProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 average_ticket = 3;
 * @return {number}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.getAverageTicket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.setAverageTicket = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated OrderTopProduct top_products = 4;
 * @return {!Array<!proto.acompanha.orders.v1.OrderTopProduct>}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.getTopProductsList = function() {
  return /** @type{!Array<!proto.acompanha.orders.v1.OrderTopProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.orders.v1.OrderTopProduct, 4));
};


/**
 * @param {!Array<!proto.acompanha.orders.v1.OrderTopProduct>} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} returns this
*/
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.setTopProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.acompanha.orders.v1.OrderTopProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.orders.v1.OrderTopProduct}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.addTopProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.acompanha.orders.v1.OrderTopProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.clearTopProductsList = function() {
  return this.setTopProductsList([]);
};


/**
 * optional string from = 5;
 * @return {string}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string to = 6;
 * @return {string}
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.GetOrdersSummaryResponse} returns this
 */
proto.acompanha.orders.v1.GetOrdersSummaryResponse.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.orders.v1.ListOrdersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.ListOrdersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.ListOrdersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.ListOrdersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.ListOrdersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
ordersList: jspb.Message.toObjectList(msg.getOrdersList(),
    proto.acompanha.orders.v1.OrderListItem.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.ListOrdersResponse}
 */
proto.acompanha.orders.v1.ListOrdersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.ListOrdersResponse;
  return proto.acompanha.orders.v1.ListOrdersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.ListOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.ListOrdersResponse}
 */
proto.acompanha.orders.v1.ListOrdersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.orders.v1.OrderListItem;
      reader.readMessage(value,proto.acompanha.orders.v1.OrderListItem.deserializeBinaryFromReader);
      msg.addOrders(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.ListOrdersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.ListOrdersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.ListOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.ListOrdersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.orders.v1.OrderListItem.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OrderListItem orders = 1;
 * @return {!Array<!proto.acompanha.orders.v1.OrderListItem>}
 */
proto.acompanha.orders.v1.ListOrdersResponse.prototype.getOrdersList = function() {
  return /** @type{!Array<!proto.acompanha.orders.v1.OrderListItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.orders.v1.OrderListItem, 1));
};


/**
 * @param {!Array<!proto.acompanha.orders.v1.OrderListItem>} value
 * @return {!proto.acompanha.orders.v1.ListOrdersResponse} returns this
*/
proto.acompanha.orders.v1.ListOrdersResponse.prototype.setOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.orders.v1.OrderListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.orders.v1.OrderListItem}
 */
proto.acompanha.orders.v1.ListOrdersResponse.prototype.addOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.orders.v1.OrderListItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.orders.v1.ListOrdersResponse} returns this
 */
proto.acompanha.orders.v1.ListOrdersResponse.prototype.clearOrdersList = function() {
  return this.setOrdersList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.orders.v1.ListOrdersResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.orders.v1.ListOrdersResponse} returns this
*/
proto.acompanha.orders.v1.ListOrdersResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.ListOrdersResponse} returns this
 */
proto.acompanha.orders.v1.ListOrdersResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.ListOrdersResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.GetOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.GetOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.GetOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.GetOrderRequest}
 */
proto.acompanha.orders.v1.GetOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.GetOrderRequest;
  return proto.acompanha.orders.v1.GetOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.GetOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.GetOrderRequest}
 */
proto.acompanha.orders.v1.GetOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.GetOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.GetOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.GetOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.orders.v1.GetOrderRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.GetOrderRequest} returns this
 */
proto.acompanha.orders.v1.GetOrderRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.GetOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.GetOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.GetOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.orders.v1.Order.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.GetOrderResponse}
 */
proto.acompanha.orders.v1.GetOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.GetOrderResponse;
  return proto.acompanha.orders.v1.GetOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.GetOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.GetOrderResponse}
 */
proto.acompanha.orders.v1.GetOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.orders.v1.Order;
      reader.readMessage(value,proto.acompanha.orders.v1.Order.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.GetOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.GetOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.GetOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.orders.v1.Order.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.orders.v1.GetOrderResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.orders.v1.GetOrderResponse} returns this
 */
proto.acompanha.orders.v1.GetOrderResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Order data = 2;
 * @return {?proto.acompanha.orders.v1.Order}
 */
proto.acompanha.orders.v1.GetOrderResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.orders.v1.Order} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.orders.v1.Order, 2));
};


/**
 * @param {?proto.acompanha.orders.v1.Order|undefined} value
 * @return {!proto.acompanha.orders.v1.GetOrderResponse} returns this
*/
proto.acompanha.orders.v1.GetOrderResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.GetOrderResponse} returns this
 */
proto.acompanha.orders.v1.GetOrderResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.GetOrderResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.DeleteOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.DeleteOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.DeleteOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.DeleteOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.DeleteOrderRequest}
 */
proto.acompanha.orders.v1.DeleteOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.DeleteOrderRequest;
  return proto.acompanha.orders.v1.DeleteOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.DeleteOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.DeleteOrderRequest}
 */
proto.acompanha.orders.v1.DeleteOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.DeleteOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.DeleteOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.DeleteOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.DeleteOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.orders.v1.DeleteOrderRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.DeleteOrderRequest} returns this
 */
proto.acompanha.orders.v1.DeleteOrderRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.TransactionSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.TransactionSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.TransactionSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
amount: jspb.Message.getFieldWithDefault(msg, 3, 0),
deduction: jspb.Message.getFieldWithDefault(msg, 4, 0),
netAmount: jspb.Message.getFieldWithDefault(msg, 5, 0),
description: jspb.Message.getFieldWithDefault(msg, 6, ""),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 7, ""),
orderId: jspb.Message.getFieldWithDefault(msg, 8, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
authorizationId: jspb.Message.getFieldWithDefault(msg, 11, ""),
source: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.TransactionSummary}
 */
proto.acompanha.orders.v1.TransactionSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.TransactionSummary;
  return proto.acompanha.orders.v1.TransactionSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.TransactionSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.TransactionSummary}
 */
proto.acompanha.orders.v1.TransactionSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeduction(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNetAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorizationId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.TransactionSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.TransactionSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.TransactionSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDeduction();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getNetAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAuthorizationId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 amount = 3;
 * @return {number}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 deduction = 4;
 * @return {number}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getDeduction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setDeduction = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 net_amount = 5;
 * @return {number}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getNetAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setNetAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string payment_method = 7;
 * @return {string}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string order_id = 8;
 * @return {string}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
*/
proto.acompanha.orders.v1.TransactionSummary.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
*/
proto.acompanha.orders.v1.TransactionSummary.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string authorization_id = 11;
 * @return {string}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getAuthorizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setAuthorizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string source = 12;
 * @return {string}
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.TransactionSummary} returns this
 */
proto.acompanha.orders.v1.TransactionSummary.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.GetOrderTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.GetOrderTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.GetOrderTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrderTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
orderUuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.GetOrderTransactionRequest}
 */
proto.acompanha.orders.v1.GetOrderTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.GetOrderTransactionRequest;
  return proto.acompanha.orders.v1.GetOrderTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.GetOrderTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.GetOrderTransactionRequest}
 */
proto.acompanha.orders.v1.GetOrderTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.GetOrderTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.GetOrderTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.GetOrderTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrderTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_uuid = 1;
 * @return {string}
 */
proto.acompanha.orders.v1.GetOrderTransactionRequest.prototype.getOrderUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.orders.v1.GetOrderTransactionRequest} returns this
 */
proto.acompanha.orders.v1.GetOrderTransactionRequest.prototype.setOrderUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.orders.v1.GetOrderTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.orders.v1.GetOrderTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
transaction: (f = msg.getTransaction()) && proto.acompanha.orders.v1.TransactionSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.orders.v1.GetOrderTransactionResponse}
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.orders.v1.GetOrderTransactionResponse;
  return proto.acompanha.orders.v1.GetOrderTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.orders.v1.GetOrderTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.orders.v1.GetOrderTransactionResponse}
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.orders.v1.TransactionSummary;
      reader.readMessage(value,proto.acompanha.orders.v1.TransactionSummary.deserializeBinaryFromReader);
      msg.setTransaction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.orders.v1.GetOrderTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.orders.v1.GetOrderTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getTransaction();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.orders.v1.TransactionSummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.orders.v1.GetOrderTransactionResponse} returns this
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional TransactionSummary transaction = 2;
 * @return {?proto.acompanha.orders.v1.TransactionSummary}
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.prototype.getTransaction = function() {
  return /** @type{?proto.acompanha.orders.v1.TransactionSummary} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.orders.v1.TransactionSummary, 2));
};


/**
 * @param {?proto.acompanha.orders.v1.TransactionSummary|undefined} value
 * @return {!proto.acompanha.orders.v1.GetOrderTransactionResponse} returns this
*/
proto.acompanha.orders.v1.GetOrderTransactionResponse.prototype.setTransaction = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.orders.v1.GetOrderTransactionResponse} returns this
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.prototype.clearTransaction = function() {
  return this.setTransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.orders.v1.GetOrderTransactionResponse.prototype.hasTransaction = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.acompanha.orders.v1);
